<template>
  <div class="page-content">
    <div class="tab-title">Videos</div>
    <el-row :gutter="20" class="program-list">
      <el-col :span="6" v-for="(item, index) in list" :key="index">
        <div class="list-item">
          <div class="img-view">
            <video class="item-img" :src="item.href"></video>
            <img
              class="play-img"
              @click="handleDrawerShow(item)"
              src="@/assets/images/home/index-play.png"
            />
          </div>
          <div class="item-title" @click="goDetail(item.aId)">
            {{ item.title }}
          </div>
          <div class="item-date">{{ item.time }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="more-text" v-if="list.length < listQuery.total" @click="handleListMore">
      View More
    </div>

    <!-- <el-drawer
      class="drawer-fixed"
      title=""
      :visible.sync="drawer"
      direction="ttb"
      :before-close="handleClose"
    >
      <div class="drawer-view">
        <video class="drawer-media" :src="currentItem.href" controls></video>
        <div class="info">
          <h2 @click="goDetail(currentItem.aId)">{{ currentItem.title }}</h2>
          <div class="date">
            {{ currentItem.time }}
          </div>
          <div class="a" @click="$goDetail(currentItem.aId, 'news')">
            {{ currentItem.source }}
          </div>
        </div>
      </div>
    </el-drawer> -->
    <el-dialog class="drawer-fixed" title="" :visible.sync="drawer" :before-close="handleClose">
      <div class="drawer-view">
        <video class="drawer-media" :src="currentItem.href" controls></video>
        <div class="info">
          <h2 @click="goDetail(currentItem.aId)">{{ currentItem.title }}</h2>
          <div class="date">
            {{ currentItem.time }}
          </div>
          <div class="a" @click="$goDetail(currentItem.aId, 'news')">
            {{ currentItem.source }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {
      drawer: false,
      currentItem: {
        href: "https://xunli-ymy.oss-cn-beijing.aliyuncs.com/video/20221026193248.mp4",
        aId: "",
        title: "",
        source: "",
      },
      listQuery: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      },
      list: [],
    };
  },
  created() {},
  mounted() {
    this.list = [];
    this.getList();
  },
  methods: {
    getList() {
      this.$get(this.$api + "/un/webmultimedia/list", {
        type: 1,
        ...this.listQuery,
      }).then((res) => {
        this.list = this.list.concat(res.rows);
        console.log(res);
        this.listQuery.total = res.total;
      });
    },
    handleListMore() {
      this.listQuery.pageNum += 1;
      this.getList();
    },
    handleDrawerShow(item) {
      this.currentItem = item;
      this.drawer = true;
    },
    goDetail(id) {
      this.$router.push({ path: "/news", query: { id: id } });
    },
    handleClose() {
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss">
.mobile .drawer-fixed .el-dialog {
  width: 98% !important;
  height: 70% !important;
}
.el-dialog {
  width: 68%;
  height: 100% !important;
  .drawer-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .drawer-media {
      width: 100%;
    }
    .info {
      padding: fh(40vh, pc) fw(40vw, pc);
      h2 {
        font-size: fh(24vh, pc);
        line-height: fh(36vh, pc);
        color: #333;
        font-weight: bold;
      }
      .date {
        font-size: fh(18vh, pc);
        line-height: fh(24vh, pc);
        padding: fh(20vh, pc) 0;
        color: #999999;
      }
      .a {
        font-size: fh(18vh, pc);
        line-height: fh(22vh, pc);
        color: #333333;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.mobile {
  .page-content {
    .program-list {
      .el-col {
        width: 100% !important;
      }

      .list-item {
        width: 100% !important;
        margin-top: 20px !important;
      }
    }
  }
}
.page-content {
  // padding: fh(60vh, pc) fw(200vw, pc);
  .more-text {
    margin: fh(60vh, pc) auto;
    font-size: fh(18vh, pc);
    color: #0077d4;
    width: max-content;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  .tab-title {
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(42vh, pc);
  }
  .program-list {
    .list-item {
      padding-top: fh(20vh, pc);
      margin-top: fh(60vh, pc);
      border-top: 1px solid #e4e4e4;
      height: fh(420vh, pc);
      overflow: hidden;
      .img-view {
        position: relative;
        width: 100%;
        height: fh(222vh, pc);
        overflow: hidden;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: 2;
        }
        img {
          position: absolute;
          width: 100%;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        .play-img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: fw(60vw, pc);
          z-index: 3;
          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
      .item-date {
        font-size: fh(18vh, pc);
        color: #999999;
      }
      .item-title {
        margin: fh(20vh, pc) 0;
        font-size: fh(21vh, pc);
        line-height: fh(29vh, pc);
        color: #333;
        display: -webkit-box; /* 使用弹性盒模型布局 */
        -webkit-line-clamp: 4; /*显示的行数*/
        -webkit-box-orient: vertical; /* 垂直方向排列*/
        overflow: hidden;
        text-overflow: ellipsis; /* 超出部分显示省略号*/
        &:hover {
          cursor: pointer;
          color: #000;
        }
      }
    }
  }
  .content-text {
    .title {
      font-size: fh(36vh, pc);
      line-height: fh(54vh, pc);
      color: #333;
      font-weight: bold;
    }
    .text {
      font-size: fh(18vh, pc);
      line-height: fh(28vh, pc);
      color: #2a2a2a;
    }
  }
  ::v-deep .el-form {
    padding-top: fh(60vh, pc);
    padding-bottom: fh(80vh, pc);
    .el-form-item {
      margin-right: fw(20vw, pc);
      .el-input__inner {
        width: fw(288vw, pc);
        border-radius: 50px;
      }
    }
  }
}
</style>
